import { EImageType } from '../../types/offer';
import { EGallerySection, IGalleryItem } from '../../types/redux/gallery';
import { GALLERY_SECTIONS_CONFIG } from './constants';
import { ECategory } from '../../types/category';
import { TMedia } from './types';

const DEFAULT_GALLERY_SECTION = EGallerySection.Gallery;
const CATEGORY_TO_GALLERY_SECTION: Partial<Record<ECategory, EGallerySection>> = {
  [ECategory.FlatSale]: EGallerySection.OffersPhotos,
  [ECategory.NewBuildingFlatSale]: EGallerySection.JKGallery,
};

interface IParameters {
  media: TMedia;
  category: ECategory;
}

export function prepareNormalImages({ media, category }: IParameters): IGalleryItem | null {
  const normalImages = media[EImageType.Normal];

  if (!normalImages || normalImages.length === 0) {
    return null;
  }

  const gallerySection = CATEGORY_TO_GALLERY_SECTION[category] || DEFAULT_GALLERY_SECTION;

  return {
    ...GALLERY_SECTIONS_CONFIG[gallerySection],
    media: normalImages,
  };
}
